import styles from "./index.module.scss";

export default function RotateGuide() {
  return (
    <div className={styles.container}>
      <p>{`Please rotate\nthe device`}</p>
    </div>
  );
}
